import React, { FC, useEffect, useState } from "react";
import { createPortal } from "react-dom";

import close from "@/assets/images/howDoesItWork/close.svg?react";

import { clsxm } from "@/utils/clsxm";

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
}

const Modal: FC<ModalProps> = ({ isOpen, onClose, children }) => {
  const [isContentVisible, setIsContentVisible] = useState(false);

  useEffect(() => {
    setIsContentVisible(isOpen);
    if (!isOpen) return;

    const originalOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = originalOverflow;
    };
  }, [isOpen]);

  if (!isOpen) return null;

  let modalRoot = document.getElementById("help-modal-root");

  if (!modalRoot) {
    modalRoot = document.createElement("div");
    modalRoot.setAttribute("id", "help-modal-root");
    document.body.appendChild(modalRoot);
  }

  return createPortal(
    <div role="dialog" aria-modal="true" className="fixed inset-0 z-50 flex flex-col">
      <div className="absolute inset-0 bg-main-button-v2/80 backdrop-blur-sm" />
      <div
        className={clsxm(
          "relative mx-auto my-12 w-full max-w-[810px] rounded-3xl transition-transform duration-300 transform",
          isContentVisible ? "translate-y-0" : "translate-y-full",
          "bg-transparent"
        )}
      >
        <button
          onClick={onClose}
          className="
            absolute -top-10 right-6 sm:-top-10
            flex items-center gap-1
            text-[16px] leading-[150%] font-medium text-white z-10
          "
        >
          Close
          <img
            src={close as unknown as string}
            alt="close"
            className="h-4 w-4"
          />
        </button>
        <div
          className={clsxm(
            "max-h-[80svh] sm:max-h-[90svh] overflow-y-auto pl-4 pr-2 sm:px-0 scrollbar-generalHelpModal scroll-smooth",
          )}
        >
          {children}
        </div>
      </div>
    </div>,
    modalRoot
  );
};

export default Modal;
